import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../assets/logo.png';
import psgLogo from '../assets/PSGLogo1.png';
import psgLogo2 from '../assets/psg2.png';

import startupLogo from '../assets/startupcopy.png';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-left">
          <div className="company-info">
            <img src={logo} alt="Company Logo" className="footer-company-logo" />
            <div className="company-details">
              <h3>Adept Knowledge Technologies</h3>
              <p>Advancing livestock health through AI/ML and<br />Connected Sensing Solutions</p>
            </div>
          </div>
          <div className="partner-logos">
            <img src={psgLogo} alt="PSG STEP Logo" className="footer-logo" />
            <img src={psgLogo2} alt="PSG STEP Logo" className="footer-logo" />

            <img src={startupLogo} alt="Startup India Logo" className="footer-logo startup-logo" />
          </div>
        </div>
        
        <div className="footer-middle">
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/knowledge-hub">Knowledge Hub</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-right">
          <div className="footer-contact">
            <h4>Get in Touch</h4>
            <div className="contact-item">
              <svg className="contact-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18" height="18">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
              </svg>
              <div className="contact-text">
                <p>PSG - Science and Technology Entrepreneurial Park (PSG-STEP),<br />E8 Block, PSG iTECH Campus, Neelambur, Coimbatore,<br /> Tamil Nadu - 641 062</p>
                <p>113, B1 Block, Karayampalayam Road, Mylampatti,<br />Chinniyampalayam, Coimbatore, Tamil Nadu - 641 062</p>
              </div>
            </div>
            <div className="contact-item">
              <svg className="contact-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18" height="18">
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
              </svg>
              <div className="contact-text">
                <p>Phone: +91 8925531013 (Preferred)</p>
                <p>Landline: +0422 2992101</p>
              </div>
            </div>
            <div className="contact-item">
              <svg className="contact-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18" height="18">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
              </svg>
              <div className="contact-text">
                <p>info@ak-tech.in</p>
              </div>
            </div>
            <div className="contact-item">
              <svg className="contact-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18" height="18">
                <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm-1 7V3.5L18.5 9H13zm-2 8H7v-2h4v2zm4-4H7v-2h8v2zm0-4H7V7h8v2z"/>
              </svg>
              <div className="contact-text">
                <p>GST: 33AAUCA0288P1Z0</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Adept Knowledge Technologies. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
